/* Fun Cases — theme.js
   Progressive enhancement only; the page is fully readable without it.
   Everything is delegated / re-initialisable so it survives Shopify's
   theme-editor section reloads. */

(function () {
  'use strict';

  /* ---- Mobile drawer (burger) ------------------------------------- */
  function initDrawer(root) {
    var burger = (root || document).querySelector('.burger');
    if (!burger || burger.dataset.bound) return;
    burger.dataset.bound = '1';
    burger.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- Best-sellers carousel arrows ------------------------------- */
  function initCarousels(root) {
    var tracks = (root || document).querySelectorAll('[data-bs-track]');
    tracks.forEach(function (track) {
      if (track.dataset.bound) return;
      track.dataset.bound = '1';
      var section = track.closest('section') || document;
      var prev = section.querySelector('[data-bs-prev]');
      var next = section.querySelector('[data-bs-next]');
      function page() {
        var cs = getComputedStyle(track);
        var pad = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
        var gap = parseFloat(cs.columnGap) || 8;
        return track.clientWidth - pad + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
    });
  }

  /* ---- Mega: hover a rail item to reveal its L3 group -------------- */
  function initMega(root) {
    var rails = (root || document).querySelectorAll('[data-mega-rail]');
    rails.forEach(function (rail) {
      if (rail.dataset.bound) return;
      rail.dataset.bound = '1';
      var mega = rail.closest('.mega');
      if (!mega) return;
      var groups = mega.querySelectorAll('[data-mega-group]');
      function show(idx) {
        groups.forEach(function (g) {
          g.classList.toggle('active', g.getAttribute('data-mega-group') === String(idx));
        });
      }
      rail.querySelectorAll('[data-mega-idx]').forEach(function (a) {
        var idx = a.getAttribute('data-mega-idx');
        a.addEventListener('mouseenter', function () { show(idx); });
        a.addEventListener('focus', function () { show(idx); });
      });
    });
  }

  /* ---- Predictive search ------------------------------------------ */
  function esc(s) {
    return (s == null ? '' : '' + s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function money(p) {
    var f = window.__fcMoney || '£{{amount}}';
    return f.replace(/\{\{\s*amount(?:_[a-z_]+)?\s*\}\}/, p);
  }

  function initPredictiveSearch(root) {
    var forms = (root || document).querySelectorAll('[data-ps-form]');
    forms.forEach(function (form) {
      if (form.dataset.psBound) return;
      form.dataset.psBound = '1';
      var input = form.querySelector('[data-ps-input]');
      var panel = form.querySelector('[data-ps-panel]');
      if (!input || !panel) return;
      var timer;

      function close() { panel.hidden = true; }
      function open() { if (panel.innerHTML) panel.hidden = false; }

      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) { panel.innerHTML = ''; close(); return; }
        panel.innerHTML = '<div class="ps-loading"><span class="ps-spinner"></span>Searching&hellip;</div>';
        panel.hidden = false;
        timer = setTimeout(function () { run(q, panel); }, 200);
      });
      input.addEventListener('focus', open);
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  function run(q, panel) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query&resources[limit]=6' +
      '&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        render(panel, q, res.products || [], res.queries || []);
      })
      .catch(function () { panel.hidden = true; });
  }

  function render(panel, q, products, queries) {
    var html = '';
    if (queries.length) {
      html += '<div class="ps-sep">Suggestions</div>';
      queries.slice(0, 4).forEach(function (x) {
        html += '<a class="ps-q" href="' + x.url + '">' + esc(x.text) + '</a>';
      });
    }
    if (products.length) {
      html += '<div class="ps-sep">Products</div>';
      products.forEach(function (p) {
        html += '<a class="ps-item" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '<span class="ps-noimg"></span>') +
          '<span class="ps-t">' + esc(p.title) + '</span>' +
          (p.price ? '<span class="ps-p">' + money(p.price) + '</span>' : '') +
          '</a>';
      });
    }
    if (!queries.length && !products.length) {
      html += '<div class="ps-sep">No matches</div>';
    }
    html += '<a class="ps-all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results for &ldquo;' + esc(q) + '&rdquo; &rarr;</a>';
    panel.innerHTML = html;
    panel.hidden = false;
  }

  /* ---- Close drawer when viewport grows past mobile --------------- */

  /* ---- Collection filter slideout --------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) {
      var d = document.querySelector('[data-filter-drawer]');
      if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('filter-open'); }
      return;
    }
    if (e.target.closest('[data-filter-close]')) {
      var d2 = document.querySelector('[data-filter-drawer]');
      if (d2) { d2.classList.remove('is-open'); d2.setAttribute('aria-hidden', 'true'); document.body.classList.remove('filter-open'); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('[data-filter-drawer].is-open');
    if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('filter-open'); }
  });

  /* ---- Collection "Load more" (append next page) ------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.dataset.url;
    if (!url) return;
    btn.classList.add('is-loading');
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-grid]');
        var grid = document.querySelector('[data-grid]');
        if (newGrid && grid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (c) { grid.appendChild(c); });
        }
        var newNote = doc.querySelector('[data-loaded-note]');
        var note = document.querySelector('[data-loaded-note]');
        if (newNote && note) note.textContent = newNote.textContent;
        var newBtn = doc.querySelector('[data-load-more]');
        if (newBtn) {
          btn.dataset.url = newBtn.dataset.url;
          btn.classList.remove('is-loading');
        } else {
          var row = btn.closest('.load-more-row');
          if (row) row.remove();
        }
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  /* ---- Phone model carousel (tabs + arrows) ----------------------- */
  function initPhoneCarousel(root) {
    (root || document).querySelectorAll('.pm-carousel').forEach(function (sec) {
      if (sec.dataset.bound) return;
      sec.dataset.bound = '1';
      var tabs = sec.querySelectorAll('[data-pm-tab]');
      var panels = sec.querySelectorAll('[data-pm-panel]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-pm-tab');
          tabs.forEach(function (x) { x.classList.toggle('active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-pm-panel') === key;
            p.classList.toggle('active', on);
            p.hidden = !on;
          });
        });
      });
      panels.forEach(function (panel) {
        var track = panel.querySelector('[data-pm-track]');
        if (!track) return;
        var prev = panel.querySelector('[data-pm-prev]');
        var next = panel.querySelector('[data-pm-next]');
        var page = function () { return Math.max(160, track.clientWidth * 0.8); };
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });
      });
    });
  }

  /* ---- Thousands-separate any [data-int] numbers ------------------ */
  function initIntFormat(root) {
    (root || document).querySelectorAll('[data-int]').forEach(function (el) {
      if (el.dataset.intDone) return;
      var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
      if (!isNaN(n)) { el.textContent = n.toLocaleString(); el.dataset.intDone = '1'; }
    });
  }

  function initAll(root) {
    initDrawer(root);
    initCarousels(root);
    initMega(root);
    initPredictiveSearch(root);
    initPhoneCarousel(root);
    initIntFormat(root);
    initScrollers(root);
  }

  /* Generic arrow scroller: [data-scroller] with [data-scroll-track] + prev/next.
     Hides arrows when there's nothing to scroll. Used by the quick filters. */
  window.__fcInitScrollers = function (root) { initScrollers(root); };
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-scroller]').forEach(function (sc) {
      if (sc._fcScroller) return;
      sc._fcScroller = true;
      var track = sc.querySelector('[data-scroll-track]');
      var prev = sc.querySelector('[data-scroll-prev]');
      var next = sc.querySelector('[data-scroll-next]');
      if (!track) return;
      function amount() { return Math.max(120, track.clientWidth * 0.7); }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();


/* ── Tough hover-swap: cards with data-hover-src fade to the Tough mockup on hover (desktop only). ── */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.addEventListener('mouseenter', function (e) {
    var media = e.target && e.target.closest && e.target.closest('[data-hover-src]');
    if (!media || media.__toughHover) return;
    media.__toughHover = true;
    var img = document.createElement('img');
    img.className = 'prod-hover';
    img.alt = '';
    img.addEventListener('load', function () { img.classList.add('is-ready'); });
    img.src = media.getAttribute('data-hover-src');
    media.appendChild(img);
  }, true);
})();
